import { render, staticRenderFns } from "./officalAcountNode.vue?vue&type=template&id=d66fe182&scoped=true&"
import script from "./officalAcountNode.vue?vue&type=script&lang=js&"
export * from "./officalAcountNode.vue?vue&type=script&lang=js&"
import style0 from "./officalAcountNode.vue?vue&type=style&index=0&id=d66fe182&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66fe182",
  null
  
)

export default component.exports